import { LogGroup } from "../.././MyHelpers";
// constant speed overshoot correction
export class Overshoot
{
	public distance: number = 0;
    public speed: number = 0;
    public duration: number = 0;

    protected logGroup: LogGroup;

	public constructor(logGroup: LogGroup)
	{
		this.logGroup = logGroup.Add("Acceleration");
	}

    public CalculateDistance(time: number): number {
    	return this.speed * time;
    }
}